// The "challenge this player" mode menu. One list everywhere a player can
// be challenged (hub Players row, ladder row, profile overlay). Constructed
// and Sandbox go through the match setup + deck pick and land an instance
// invite; Draft and Sealed open the event creator with the player pre-invited.
import { PopoverPanel, PopoverMenuItem, PopoverMenuHeader } from './ui/popoverMenu';
import { k, t } from '../localization/t';

// Player-facing names. 'match' is the instance key for constructed 1v1
// (format constructed/peasant, stakes ranked/casual).
export const CHALLENGE_MODES = [
  { key: 'match', label: k('Constructed'), caption: k('Ranked or casual, your deck') },
  { key: 'sandbox', label: k('Sandbox'), caption: k('Any deck, no rewards') },
  { key: 'draft', label: k('Draft'), caption: k('Pick and pass, then play') },
  { key: 'sealed', label: k('Sealed'), caption: k('Six packs each, then play') },
];

function looksFor(player, key) {
  const modes = player?.lfg?.modes || [];
  if (key === 'match') return modes.includes('ranked') || modes.includes('casual');
  return modes.includes(key);
}

export default function ChallengeMenu({ player, onPick, style }) {
  return (
    <PopoverPanel style={{ minWidth: '13cqw', ...style }}>
      <PopoverMenuHeader>{player?.name ? t('Challenge {name}', { name: player.name }) : t('Challenge player')}</PopoverMenuHeader>
      {CHALLENGE_MODES.map((m) => (
        <PopoverMenuItem
          key={m.key}
          label={t(m.label)}
          caption={looksFor(player, m.key) ? t('They are looking for one') : t(m.caption)}
          onClick={() => onPick(m.key)}
        />
      ))}
    </PopoverPanel>
  );
}
